var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 16H10.5V1.71429C10.5 0.767857 9.91211 0 9.1875 0H4.8125C4.08789 0 3.5 0.767857 3.5 1.71429V16ZM5.25 2.28571H8.75V3.42857H5.25V2.28571ZM14 5.14286V14.2857C14 15.2321 13.4121 16 12.6875 16H11.375V3.42857H12.6875C13.4121 3.42857 14 4.19643 14 5.14286ZM2.625 16H1.3125C0.587891 16 0 15.2321 0 14.2857V5.14286C0 4.19643 0.587891 3.42857 1.3125 3.42857H2.625V16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSpace);
export default __webpack_public_path__ + "static/media/IcSpace.831d6382d5b28824fd4b107855bf3277.svg";
export { ForwardRef as ReactComponent };